import Layout from 'Nori/Layout';
import Container from 'Nori/Container';
import SplitContent from 'Custom/Split/SplitContent';
import HeroFull from 'Nori/Hero/HeroFull';
import RichText from 'Custom/RichText';
import AjustableImage from 'Custom/AjustableImage';
import BannerCTA from 'Custom/BannerCTA';
import ItemBreakpoint from 'Custom/ItemBreakpoint/index';

import BLUE_BG from 'Images/background/blue-bg.png';
import BLUE_BG_MOBILE from 'Images/background/blue-bg-mobile.png';
import CHECK_IMAGE from 'Images/misc/checkmark-new.png';
import CHECK_IMAGE_MOBILE from 'Images/misc/checkmark-new-mobile.png';
import PocketCost from 'Custom/PocketCost';

import styles from 'styles/pages/cost.module.scss';

const HEAD = {
  title:
    'NEXPLANON® (etonogestrel implant) 68 mg Radiopaque Cost | Pricing & Coverage',
  description:
    'Learn about the cost of NEXPLANON® (etonogestrel implant) 68 mg Radiopaque, including insurance coverage and potential no-cost options under the Affordable Care Act (ACA).',
  keywords: 'Nexplanon Cost, Birth Control Implant Cost, Nexplanon Price, Nexplanon Payment Options',
};

const CTA_BUTTON = {
  showModal: false,
  href: '/insurance-coverage/',
  label: 'Learn More',
  target: '_self',
};

const COST_JOB_CODE = 'US-XPL-117873 01/26';

const HeroBannerContent = () => {
  return (
    <div className={styles['content-wrap']} data-qa-tag="hero-content">
      <RichText data-qa-tag="hero-richtext">
        <div className={styles.wtePage} data-qa-tag="cost-hero-wrapper">
          <h4 data-qa-tag="title-cost">COST</h4>
          <div
            className={styles.middleHeroText}
            data-qa-tag="subtitle-can-you-get-nexplanon-for-free"
          >
            can you get <span data-qa-tag="span-nexplanon">Nexplanon</span> for
            free<label>?*</label>
          </div>
          <p
            className={styles.intro}
            data-qa-tag="text-affordable-care-act-intro"
          >
            You may be able to get NEXPLANON for free, as a result of the
            Affordable Care Act.
          </p>
          <p
            className={styles.caption}
            data-qa-tag="text-affordable-care-act-disclaimer"
          >
            *The Affordable Care Act (ACA) covers one type of birth control from
            each of 18 FDA-approved categories of birth control for women
            without charging a co-payment or co-insurance. This coverage
            includes the arm implant, NEXPLANON. Some patients may still be
            responsible for other costs associated with the product. This could
            include fees associated with insertion and/or removal procedures.
          </p>
        </div>
      </RichText>
    </div>
  );
};

export default function Home() {
  return (
    <Layout head={HEAD}>
      <div className={styles.heroWrapper} data-qa-tag="hero-wrapper">
        <ItemBreakpoint breakpoint={'lg'}>
          <HeroFull image={BLUE_BG} data-qa-tag="hero-desktop-image">
            <HeroBannerContent></HeroBannerContent>
          </HeroFull>
          <HeroFull image={BLUE_BG_MOBILE} data-qa-tag="hero-mobile-image">
            <HeroBannerContent></HeroBannerContent>
          </HeroFull>
        </ItemBreakpoint>
      </div>
      <section
        className={styles.affordableCare}
        data-qa-tag="section-affordable-care"
      >
        <SplitContent
          data-design-visible="visible_vd"
          data-design-type="module"
          data-design-nori_id="Inline Content"
          data-design-module_name="the Affordable Care Act covers NEXPLANON"
          data-design-module_no="02"
          data-qa-tag="splitcontent-affordable-care-act-covers-nexplanon"
        >
          <ItemBreakpoint
            breakpoint="md"
            data-qa-tag="itembreakpoint-checkmark-image"
          >
            <AjustableImage
              background="secondary2Light"
              image={{ src: CHECK_IMAGE, style: { width: 432 }, alt: '' }}
              data-qa-tag="image-checkmark-desktop"
            />
            <AjustableImage
              background="secondary2Light"
              image={{ src: CHECK_IMAGE_MOBILE, alt: '' }}
              data-qa-tag="image-checkmark-mobile"
            />
          </ItemBreakpoint>
          <>
            <RichText data-qa-tag="richtext-affordable-care-act-description">
              <h2 data-qa-tag="title-affordable-care-act-covers-nexplanon">
                The Affordable Care Act covers NEXPLANON
              </h2>
              <p data-qa-tag="text-aca-legislation-description">
                As a result of the ACA legislation, the ACA covers one type of
                birth control from each of 18 FDA-approved categories of birth
                control for women without a co-payment or co-insurance. Even if
                you haven't met your deductible.
              </p>
            </RichText>
          </>
        </SplitContent>
      </section>
      <Container
        size="md"
        className={styles.howMuch}
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name="how much might you have to pay for NEXPLANON?"
        data-design-module_no="03"
        data-qa-tag="container-how-much-might-you-pay"
      >
        <RichText data-qa-tag="richtext-cost-information">
          <h2 className="mb" data-qa-tag="title-how-much-might-you-pay">
            How much might you have to pay for NEXPLANON?
          </h2>

          <p className="body-text" data-qa-tag="text-check-insurance-plan">
            Once you and your doctor have decided that NEXPLANON is right for
            you, check with your insurance plan for cost and coverage
            information.
          </p>
          <p className="body-text" data-qa-tag="text-out-of-pocket-depends">
            Figuring out what you might pay out of pocket depends on your
            insurance plan.
          </p>
          <p className="body-text" data-qa-tag="text-list-price">
            The list price for one rod (for up to 5 years<sup>†</sup> of
            continuous pregnancy prevention) of NEXPLANON is $1,275.36.
            <sup data-qa-tag="sup-reference-a">§</sup>
          </p>
          <div className="caption" data-qa-tag="text-removal-disclaimer">
            <sup>†</sup>NEXPLANON must be removed by the end of the fifth year.
          </div>
        </RichText>
      </Container>
      <div
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name="96% of patient claims for NEXPLANON had $0 out-of-pocket costs"
        data-design-module_no="04"
        data-qa-tag="section-pocket-cost-claims"
        className={styles.pocketCostContainer}
      >
        <PocketCost data-qa-tag="component-pocket-cost" />

        <Container
          className={styles.references}
          data-qa-tag="container-references"
        >
          <RichText data-qa-tag="richtext-references">
            <p className="body-text" data-qa-tag="text-reference-a">
              <sup className={styles.sup} data-qa-tag="sup-a">
                §
              </sup>
              The list price is current as of January 2026. The list price does
              not include other treatment-related costs, such as insertion
              and/or removal procedure fees. Most women will not pay the list
              price, although it may have an impact on your out-of-pocket costs.
            </p>
            <p className="body-text" data-qa-tag="text-reference-b">
              <sup className={styles.sup} data-qa-tag="sup-b">
                ‡
              </sup>
              Source: IQVIA LAAD Mix and Remit Datasets May 2024-Apr 2025. Data
              available on request from Organon Professional Services-DAP, 30
              Hudson Street, Jersey City, NJ 07302. Please specify information
              package US-XPL-117769.
            </p>
          </RichText>
        </Container>
      </div>{' '}
      <BannerCTA
        button={CTA_BUTTON}
        color="secondary2"
        moduleName="having discussions about insurance?"
        moduleNo="05"
        className={`calling-dr ${styles.centerBanner}`}
        data-qa-tag="bannercta-insurance-discussions"
      >
        <>
          <h4 data-qa-tag="title-having-discussions-about-insurance">
            Having discussions about insurance?
          </h4>
          <p className="body-text" data-qa-tag="text-step-by-step-instructions">
            We have step-by-step instructions to help you understand your
            coverage.
          </p>
        </>
      </BannerCTA>
    </Layout>
  );
}
